import { render } from "./CollectionCardLevel.vue?vue&type=template&id=0aeef124"
import script from "./CollectionCardLevel.vue?vue&type=script&lang=js"
export * from "./CollectionCardLevel.vue?vue&type=script&lang=js"

import "./CollectionCardLevel.vue?vue&type=style&index=0&id=0aeef124&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__